// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { BehaviorSubject, Observable } from 'rxjs';

// --- HS Code
import { SurveyResponseTypes, InteractiveReportTypeModel, StylesTeamRoleTypes } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class InteractiveIndicatorBaseService {

  private _stylesTeamRoleType$: BehaviorSubject<StylesTeamRoleTypes>;
  get stylesTeamRoleType$(): Observable<StylesTeamRoleTypes> {
    return this._stylesTeamRoleType$;
  }

  private _reportTypeList$: BehaviorSubject<InteractiveReportTypeModel[]>;
  get reportTypeList$(): Observable<InteractiveReportTypeModel[]> {
    return this._reportTypeList$;
  }

  constructor() {
    this._stylesTeamRoleType$ = new BehaviorSubject<StylesTeamRoleTypes>(StylesTeamRoleTypes.Leader);
    this._reportTypeList$ = new BehaviorSubject<InteractiveReportTypeModel[]>([]);
  }

  changeStylesTeamRoleType(type: StylesTeamRoleTypes): void {
    this._stylesTeamRoleType$.next(type);
  }

  loadReportTypes() {
    const reportTypes: InteractiveReportTypeModel[] = [
      {
        key: 'self',
        title: 'interactiveIndicatorSelfScore',
        type: SurveyResponseTypes.self,
      },
      {
        key: 'benchmark',
        title: 'interactiveIndicatorBenchmarkScore',
        type: SurveyResponseTypes.benchmark,
      },
      {
        key: 'other',
        title: 'interactiveIndicatorOthersScore',
        type: SurveyResponseTypes.other,
      }
    ];
    this._reportTypeList$.next(reportTypes);
  }

  getPrevReportType(key: string) {
    const reportTypes = this._reportTypeList$.value;
    const index = reportTypes.findIndex(r => r.key === key);
    if (index === -1) {
      return null;
    }
    let prevIndex = index - 1;
    if (prevIndex < 0) {
      prevIndex = reportTypes.length - 1;
    }
    return reportTypes[prevIndex];
  }

  getNextReportType(key: string) {
    const reportTypes = this._reportTypeList$.value;
    const index = reportTypes.findIndex(r => r.key === key);
    if (index === -1) {
      return null;
    }
    let nextIndex = index + 1;
    if (nextIndex >= reportTypes.length) {
      nextIndex = 0;
    }
    return reportTypes[nextIndex];
  }
}
